import { useLocation, useNavigate } from 'react-router-dom';

export default function Pago() {
  const { search } = useLocation();
  const navigate = useNavigate();

  const params = new URLSearchParams(search);
  const offerId = params.get('offerId');

  const validationMessage =
    '¡El Umbral está ante ti! Estás a un solo paso de trascender lo gratuito e ingresar al terror que lo consume todo. Completa tu pago para que el acceso total te sea concedido. Es posible que se te solicite iniciar sesión de nuevo para validar tu identidad.';

  if (!offerId) return <p>No se recibió información del plan</p>;

  return (
    <div
      style={{
        height: '100vh',
        overflow: 'hidden',
        backgroundColor: '#ffffff',
        padding: '30px 20px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <div style={{ width: '100%', marginBottom: '10px' }}>
        <button
          onClick={() => navigate('/p/IICl5KrA/freemium')}
          style={{
            padding: '10px 15px',
            backgroundColor: '#133639',
            color: '#fff',
            border: 'none',
            borderRadius: '6px',
            cursor: 'pointer',
            fontWeight: 'bold',
          }}
        >
          ← Volver
        </button>
      </div>

      <div
        style={{
          color: '#133639',
          backgroundColor: '#ffffff',
          padding: '15px',
          marginBottom: '20px',
          width: '100%',
          borderRadius: '8px',
          textAlign: 'center',
          fontSize: '1.1em',
          fontWeight: 'bold',
        }}
      >
        {validationMessage}
      </div>

      <div
        data-cleeng-widget="checkout"
        data-cleeng-publisher-id="192028546"
        data-cleeng-offer-id={offerId}
        data-cleeng-language="es-ES"
        style={{
          flexGrow: 1,
          width: '100%',
        }}
      />
    </div>
  );
}